
import { defineComponent, onBeforeMount, reactive } from 'vue'

import NewModal from '@/common/new-components/NewModal/index.vue'
import NewSelect from '@/ui-kit/NewSelect/index.vue'

// @services
import locationAPI from '@/new-services/location.service'

// validations
import useVuelidate from '@vuelidate/core'
import { required, integer } from '@vuelidate/validators'
import { CityT } from '@/core/types/cities.types'

export default defineComponent({
    components: {
        NewModal,
        NewSelect,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        parent: {
            type: String,
            default: '-',
        },
    },
    emits: ['submit', 'cancel'],
    setup(props, { emit }) {
        const state = reactive({
            is_loading: false,
        })

        const payload = reactive({
            fromCityId: null as number | null,
            toCityId: null as number | null,
        })

        const SubdirectionValidation = {
            fromCityId: { required, integer },
            toCityId: { required, integer },
        }

        const validation$ = useVuelidate(SubdirectionValidation, payload)

        const data_state = reactive({
            cities: {
                is_loading: false,
                is_failed: false,
                list: [] as CityT[],
            },
        })

        const onSubmit = () => {
            if (props.loading) return

            validation$.value.$touch()
            if (validation$.value.$invalid) return

            emit('submit', payload.fromCityId, payload.toCityId)
        }

        const onCancel = () => {
            if (props.loading) return
            emit('cancel')
        }

        const loadCities = async (search?: string) => {
            try {
                data_state.cities.is_loading = true

                const response = await locationAPI.getCities(undefined, search)
                data_state.cities.list = response.data.data
                data_state.cities.is_failed = false
            } catch (error) {
                data_state.cities.is_failed = true
                console.error(error)
            } finally {
                data_state.cities.is_loading = false
            }
        }

        const searchCity = (search_query: string) => {
            loadCities(search_query)
        }

        const unshiftFindedCity = async (city: CityT) => {
            await loadCities()
            data_state.cities.list.unshift(city)
        }

        onBeforeMount(loadCities)

        return {
            state,
            payload,
            data_state,
            //
            validation$,
            //
            onSubmit,
            onCancel,
            loadCities,
            searchCity,
            unshiftFindedCity,
        }
    },
})
